import React from 'react';
import type { FJ750 } from '../../../services/pwj220Api';
import LookupField from '../../../components/LookupField';

interface Props {
  formData: Partial<FJ750>;
  isEditing: boolean;
  onChange: (field: keyof FJ750, value: any) => void;
}

const Tab4Remarks: React.FC<Props> = React.memo(({ formData, isEditing, onChange }) => {
  const val = (f: keyof FJ750) => (formData[f] ?? '') as string;

  return (
    <div className="form-grid">
      <label>備註代號</label>
      <LookupField
        lookupType="remarkTemplate"
        value={val('fj750_51')}
        onChange={(code) => onChange('fj750_51', code)}
        disabled={!isEditing}
        title="選擇備註代號"
      />

      <label>備註說明</label>
      <textarea
        value={val('fj750_52')}
        onChange={e => onChange('fj750_52', e.target.value)}
        disabled={!isEditing}
        className="form-textarea"
        rows={4}
      />
    </div>
  );
});

export default Tab4Remarks;
